// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import { 
  Card, Grid
} from "@mui/material";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function ProjectCard({ title, subtitle, description, color, image, children, ...rest }) {
  return (
    <Card sx={{ mt: 3 }}>
      <Grid container>
        {image ? (
          <Grid item xs={12} md={4}>
            <MKBox width="100%" pt={2} pb={1} px={2}>
              <MKBox
                component="img"
                src={image}
                alt={name}
                width="100%"
                borderRadius="md"
                shadow="lg"
              />
            </MKBox>
          </Grid>
        ) : null}
        <Grid item xs={12} md={image ? 8 : 12} sx={{ my: "auto" }}>
          <MKBox pt={{ xs: 3, lg: 4 }} pb={2.5} pr={4} pl={{ xs: 4, lg: 1 }} lineHeight={1}>
            <MKTypography variant="h5">
              {title}
            </MKTypography>
            <MKTypography variant="h6" color={color} mb={1}>
              <a href={subtitle} target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'none' }}>
                {subtitle}
              </a>
            </MKTypography>
            <MKTypography variant="body2" color="text">
              {description}
            </MKTypography>
          </MKBox>
        </Grid>
      </Grid>
    </Card>
  );
}

// Typechecking props for the FaqCollapse
ProjectCard.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  description: PropTypes.string,
  color: PropTypes.string,
  image: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default ProjectCard;